






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
@Component({})
export default class AccountLoginCmp extends Vue {
  private info: any = {
    手机号: "",
    密码: ""
  };
  private rules: any = {
    手机号: [{ required: true, message: "用户名必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }]
  };
  /**
   * @description 登录
   */
  private login() {
    (this.$refs.loginForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = {
          手机号: this.info["手机号"],
          密码: this.info["密码"]
        };
        this.$store
          .dispatch("login", params)
          .then(() => {
            this.$router.push("/main/szjx/szjc-folder");
          })
          .catch((error: string) => {
            console.log(error);
            this.$message.error(error);
          });
      }
    });
  }
}
